// Маппинг кодов видов спорта в названия (битовые флаги)
export const sportCodeToName: Record<number, string> = {
  1: 'TableTennis',           // 1L << 0
  2: 'Basketball',            // 1L << 1
  4: 'Volleyball',            // 1L << 2
  8: 'Badminton',             // 1L << 3
  16: 'Paintball',            // 1L << 4
  32: 'Football',             // 1L << 5
  64: 'Hockey',               // 1L << 6
  128: 'Tennis',              // 1L << 7
  256: 'Boxing',              // 1L << 8
  512: 'Lasertag',            // 1L << 9
  1024: 'Running',            // 1L << 10
  2048: 'Golf',               // 1L << 11
  4096: 'Pool',               // 1L << 12
  8192: 'Fitness',            // 1L << 13
  16384: 'Bowling',           // 1L << 14
  32768: 'Driving',           // 1L << 15
  65536: 'Rugby',             // 1L << 16
  131072: 'AmericanFootball', // 1L << 17
  262144: 'Chess',            // 1L << 18
  524288: 'IceSkating',       // 1L << 19
  1048576: 'Baseball',        // 1L << 20
  2097152: 'FieldHockey',     // 1L << 21
  4194304: 'Workout',         // 1L << 22
  8388608: 'Barbershop',      // 1L << 23
  16777216: 'Squash',         // 1L << 24
  33554432: 'Swimming',       // 1L << 25
  67108864: 'Skate',          // 1L << 26
  134217728: 'Climbing',      // 1L << 27
  268435456: 'Snow',          // 1L << 28
  536870912: 'Rent',          // 1L << 29
  1073741824: 'Dance',        // 1L << 30
  2147483648: 'Wrestling',    // 1L << 31
  4294967296: 'Yoga',         // 1L << 32
  8589934592: 'Cyber',        // 1L << 33
  17179869184: 'Skiing',      // 1L << 34
  34359738368: 'Bicycle',     // 1L << 35
  68719476736: 'Extreme',     // 1L << 36
  137438953472: 'Kickboxing', // 1L << 37
  274877906944: 'MMA',        // 1L << 38
  549755813888: 'Fighting',   // 1L << 39
  1099511627776: 'Darts',     // 1L << 40
  2199023255552: 'Other',     // 1L << 41
};

// Маппинг английских названий в русские
const sportNameToRussian: Record<string, string> = {
  'TableTennis': 'Настольный теннис',
  'Basketball': 'Баскетбол',
  'Volleyball': 'Волейбол',
  'Badminton': 'Бадминтон',
  'Paintball': 'Пейнтбол',
  'Football': 'Футбол',
  'Hockey': 'Хоккей',
  'Tennis': 'Теннис',
  'Boxing': 'Бокс',
  'Lasertag': 'Лазертаг',
  'Running': 'Бег',
  'Golf': 'Гольф',
  'Pool': 'Бильярд',
  'Fitness': 'Фитнес',
  'Bowling': 'Боулинг',
  'Driving': 'Автодром',
  'Rugby': 'Регби',
  'AmericanFootball': 'Американский футбол',
  'Chess': 'Шахматы',
  'IceSkating': 'Каток',
  'Baseball': 'Бейсбол',
  'FieldHockey': 'Хоккей на траве',
  'Workout': 'Воркаут',
  'Barbershop': 'Барбершоп',
  'Squash': 'Падел и сквош',
  'Swimming': 'Плавание',
  'Skate': 'Скейтборд',
  'Climbing': 'Скалолазание',
  'Snow': 'Сноуборд',
  'Rent': 'Прокат',
  'Dance': 'Танцы',
  'Wrestling': 'Борьба',
  'Yoga': 'Йога',
  'Cyber': 'Киберспорт',
  'Skiing': 'Лыжи',
  'Bicycle': 'Велоспорт',
  'Extreme': 'Экстрим',
  'Kickboxing': 'Кикбоксинг',
  'MMA': 'ММА',
  'Fighting': 'Единоборства',
  'Darts': 'Дартс',
  'Other': 'Другое',
};

// Функция для конвертации кода вида спорта в название
export const getSportNameFromCode = (code: number | string): string => {
  const numCode = typeof code === 'string' ? parseInt(code, 10) : code;
  return sportCodeToName[numCode] || 'Unknown';
};

// Функция для получения русского названия вида спорта
export const getSportRussianName = (code: number | string): string => {
  const englishName = getSportNameFromCode(code);
  return sportNameToRussian[englishName] || englishName;
};

// Функция для разбора битовой маски видов спорта
export const parseSportCodes = (sportValue: number | number[] | undefined): number[] => {
  if (!sportValue) return [];
  
  if (Array.isArray(sportValue)) {
    return sportValue;
  }
  
  // Если это число, разбираем битовую маску
  const codes: number[] = [];
  let value = typeof sportValue === 'string' ? parseInt(sportValue, 10) : sportValue;
  
  // Проверяем каждый бит
  Object.keys(sportCodeToName).forEach(codeStr => {
    const code = parseInt(codeStr, 10);
    // JS bitwise is 32-bit; flags >= 1L << 32 must be tested by division
    if (Math.floor(value / code) % 2 === 1) {
      codes.push(code);
    }
  });
  
  return codes;
};

// Функция для получения списка видов спорта с русскими названиями
export const getSportsList = (sportValue: number | number[] | undefined): Array<{ code: number; name: string; russianName: string }> => {
  const codes = parseSportCodes(sportValue);
  return codes.map(code => ({
    code,
    name: getSportNameFromCode(code),
    russianName: getSportRussianName(code),
  }));
};

